import './What.css'
import React from 'react'
import img1 from '../img/Landing Pages3.png'
import img2 from '../img/Landing Pages5.png'
import img3 from '../img/Landing Pages6.png'
import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'

function What() {
  const [ref1, inView1] = useInView({ triggerOnce: true });
  const [ref2, inView2] = useInView({ triggerOnce: true });
  const [ref3, inView3] = useInView({ triggerOnce: true });

  return (
    <div className='what' id='whatid'>
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <motion.div
              ref={ref1}
              initial={{ opacity: 0, x: 100 }}
              animate={inView1 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 1 }}
            >
              <div className="card boxwhat">
                <div className="card-body">
                  <img src={img1} alt="ماهي المواقع الإلكترونية؟" />
                  <p>
                  المواقع الإلكترونية(<span className="highlight">Websites</span>) هي منصات رقمية مستقلة تُنشأ خصيصًا لأغراض مختلفة، سواء كانت تسويقية، إعلامية، تعليمية أو ترفيهية
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
          <div className="col-lg-4 col-md-6 mb-3 mb-sm-0">
            <motion.div
              ref={ref2}
              initial={{ opacity: 0, y: -50 }}
              animate={inView2 ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1, delay: 0.3 }}
            >
              <div className="card boxwhat">
                <div className="card-body">
                  <img className='mb-2' src={img2} alt="ماهي المواقع الإلكترونية؟" />
                  <p>
                  يتم تصميم المواقع الإلكترونية لاستقبال الزوار من خلال نقرهم على روابط معينة، سواء كان ذلك عبر إعلانات الإنترنت، الحملات البريدية الإلكترونية، روابط وسائل التواصل الاجتماعي، أو غيرها من المصادر.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>
          <div className="col-lg-4 col-md-6 mb-3 mb-sm-0">
            <motion.div
              ref={ref3}
              initial={{ opacity: 0, x: 100 }}
              animate={inView3 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 1, delay: 0.6 }}
            >
              <div className="card boxwhat">
                <div className="card-body">
                  <img className='mb-2' src={img3} alt="الهدف من المواقع الإلكترونية" />
                  <p>الهدف الرئيسي للمواقع الإلكترونية هو تحويل الزوار إلى عملاء محتملين أو تحقيق أهداف معينة، مثل تعبئة نموذج، تحميل ملف، التسجيل في حدث، أو شراء منتج. تسعى المواقع أيضًا إلى تقديم محتوى مفيد وجذاب يعزز من تجربة المستخدم ويبني علاقة مستدامة مع الجمهور.</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default What
